import { render, staticRenderFns } from "./Embeds.tpl?vue&type=template&id=5152997d&"
import script from "./Embeds.vue?vue&type=script&lang=ts&"
export * from "./Embeds.vue?vue&type=script&lang=ts&"
import style0 from "./Embeds.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports